import { redirect } from "next/navigation";
import { getSession } from "@/lib/auth/session";
import { LoginForm } from "./login-form";
import { LoginScene } from "./login-scene";
import {
  Card,
  CardBody,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const dynamic = "force-dynamic";

export default async function LoginPage({
  searchParams,
}: {
  searchParams: Promise<{ next?: string }>;
}) {
  const session = await getSession();
  if (session) redirect("/dashboard");

  const { next } = await searchParams;

  return (
    <LoginScene>
      <div className="w-full max-w-sm">
        <Card className="border-white/10 bg-black/55 text-white shadow-2xl backdrop-blur-md">
          <CardHeader>
            <CardTitle className="text-white">Connexion</CardTitle>
            <CardDescription className="text-white/60">
              Accès réservé aux super-administrateurs.
            </CardDescription>
          </CardHeader>
          <CardBody>
            <LoginForm next={next} />
          </CardBody>
        </Card>

        <p className="mt-6 text-center text-[11px] text-white/45">
          Tu n&apos;es pas super-admin ?{" "}
          <span className="text-white/65">
            Connecte-toi sur ton sous-domaine tenant habituel.
          </span>
        </p>
      </div>
    </LoginScene>
  );
}
